import React, { FunctionComponent, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useMutation, useQuery } from "@tanstack/react-query";
// import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { fetch_one } from "../../../../lib/v31lib";
// import { loginAtom } from '../../../../lib/auth';

// import Lenis from "lenis";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { gsap } from "gsap";

import {
  Grid,
} from '@mui/material';

// import {
//   Footer,
//   WhiteSection
// } from '../../../../components/v2/custom';
import {
  Typography
} from '../../../../components/v2/styled';

// import { Meeting } from '../../../../models/Meeting';
// import { User } from '../../../../models/User';

// const { DateTime } = require("luxon");

type Props = {
  question: {
    top_info?: {[z:string]: string;};
    image_url?: {[z:string]: string;};
    question: {[z:string]: string;};
    toelichting?: {[z:string]: string;};
    bottom_info?: {[z:string]: string;};
    quorum?: number;
  };
  hidden: boolean;
}

export const MeetingVoteSlideProfile: FunctionComponent<Props> = ({question, hidden}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  // const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);







  return <>
    {!!question.top_info && !!question.top_info[i18n.resolvedLanguage || 'nl'] && <Grid xs={12} sx={{display: !!hidden ? 'none' : 'block'}}>
      <Typography html altLinks>{question.top_info[i18n.resolvedLanguage || 'nl']}</Typography>
    </Grid>}
    {!!question.image_url && <Grid xs={12} sm={4} sx={{display: !!hidden ? 'none' : 'block'}}>
      <img src={question.image_url[i18n.resolvedLanguage || 'nl']} alt="" style={{
        maxHeight: 300,
        maxWidth: '100%'
      }} />
    </Grid>}
    <Grid xs={12} sm={!!question.image_url ? 8 : 12} sx={{display: !!hidden ? 'none' : 'block'}}>
      <Typography html altLinks sx={{
        fontSize: '1.8em',
        display: 'block',
        lineHeight: '1.2em'
      }}>{question.question[i18n.resolvedLanguage || 'nl']}</Typography>
      {!!question.toelichting && question.toelichting[i18n.resolvedLanguage || 'nl'] && <Typography html altLinks>{question.toelichting[i18n.resolvedLanguage || 'nl']}</Typography>}
    </Grid>
    {!!question.bottom_info && !!question.bottom_info[i18n.resolvedLanguage || 'nl'] && <Grid xs={12} sx={{display: !!hidden ? 'none' : 'block'}}>
      <Typography html altLinks>{question.bottom_info[i18n.resolvedLanguage || 'nl']}</Typography>
    </Grid>}
    {!!question.quorum && question.quorum > 0 && <Grid xs={12} sx={{display: !!hidden ? 'none' : 'block', marginTop: 2}}>
      999 - yes1 - no0 - blank2
    </Grid>}
  </>;
}

